<template>
    <div>
        <div class="flex flex-wrap w-full">
            <div class="w-full">
                <div class="card db-card  bg-white border border-gray-200 dark:bg-slate-800 dark:border-slate-600">

                    <div class="flex flex-wrap ">
                        <div class="w-full">
                        </div>
                    </div>

                    <div class="bg-white">
                        <standard-table predefinedStyle="default" ref="table" :dataset="filteredInvoices"
                            :columns="columns" :workingOn="workingOn" @table:sort="sortTable($event)"
                            @menu:cancellation="cancellationInvoice($event.data)"
                            @menu:cancelOrder="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:credit_note="this.emitter.emit($event.childevent.emit, $event.data)"
                            :menuOptions="menuOptions"
                            @menu:open="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:paid="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:copy="this.emitter.emit('kooi:menu:copyDocument', $event.data)"
                            @menu:proforma_to_real="this.emitter.emit('kooi:menu:proforma_to_real', $event.data)"
                            @table:edit="this.emitter.emit('kooi:menu:editDocument', $event)"
                            @menu:finalize="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:create_release="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:delete="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:reject="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:accept="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:openpdf="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:sendmail="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:abort="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:validatepdf="this.emitter.emit($event.childevent.emit, $event.data)"
                            @menu:emit="this.emitter.emit($event.childevent.emit, $event.data)"
                            pretranslate="labels.kooi.tables." :isCheckable="false" :isEditable="true"
                            :isDeleteable="false" :menuViaKey="menuViaKeys">
                        </standard-table>
                    </div>

                </div>
            </div>
        </div>


        <div>

        </div>

        <send-mail-modal :open.sync="sendMailModal" :document="sendDocument" :documentType="sendDocumentType"
            templateFilter="OOI" @close="sendMailModal = false"></send-mail-modal>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import sendMailModal from '../email/SendMailModal.vue';
import { useKooiNavigation } from '../../pinia/KooiNavigation';
import { useIsDisabled } from "./useKooi.js";
import { additionalInvoiceColumns, isDeveloperMode } from "../developers/developerMode.js";
export default {
    components: { sendMailModal },
    data() {
        return {
            selectedInvoices: [],
            menu: {
                open: false,
            },
            mailMenu: {
                isOpen: true,
            },
            menuOpen: false,
            validation: {
                open: false,
                infos: {
                    generate: true,
                },
                element: null,
                loading: false,
            },
            sendMailModal: false,
            sendDocument: null,
            sendDocumentType: null,
        }
    },
    setup() {
        const kooiNavigation = useKooiNavigation();
        const { updateDisabled: updateKooiDisabled, policies: policiesKooi } = useIsDisabled();

        return {
            kooiNavigation,
            updateKooiDisabled,
            policiesKooi,
        };
    },
    unmounted() {
        this.emitter.off("cancel-save-button:additional:new");
        this.emitter.emit("cancel-save-button:additional", { type: "adder", value: false });
    },
    mounted() {
        this.emitter.emit("cancel-save-button:setStatus", null);
        this.emitter.emit("cancel-save-button:extra:remove", "find:products:shinkiba");
        this.emitter.emit("cancel-save-button:additional", { type: "adder", value: !this.updateKooiDisabled });
        this.emitter.on("cancel-save-button:additional:new", (data) => {
            this.createNewInvoice();
        })
    },
    methods: {
        async sortTable(event) {
            var column = JSON.parse(JSON.stringify(event));
            if (column.direction && column.direction == "ASC") {
                column.direction = "DESC";
            } else {
                column.direction = "ASC";
            }
            this.$store.commit("kooi/updateColumn", { column: column, type: this.subkey });
            this.$store.dispatch("kooi/loadTable", this.subkey);
        },
        async openPdf(event) {
            if (event && event.pdf) {
                if (this.subkey == "offers") {
                    var item = event.pdf.find(item => item.type == "offer");
                }
                if (this.subkey == "orders") {
                    var item = event.pdf.find(item => item.type == "order");
                }
                if (this.subkey == "invoices") {
                    var item = event.pdf.find(item => item.type == "inv");
                }
                if (item && item.id != 0) {
                    window.open(this.$store.state.settings.url + "/" + this.internalCompany.id + "/pdf/" + item.id + "/latest", "_blank");
                }
            }
        },
        async generatePDF() {
            this.validation.open = false;
            this.validation.loading = true;
            await axios
                .get(
                    this.$store.state.settings.url +
                    "/api/v1/" +
                    this.internalCompany.id +
                    "/" +
                    "generate_pdf/" +
                    this.validation.element.kooi_id +
                    "/" +
                    this.subkey +
                    "/" +
                    this.validation.element.id
                )
                .then((response) => {
                    this.validation.infos = response.data;
                    this.validation.loading = false;
                });
        },
        async validatePdf(event) {
            this.validation.open = true;
            this.validation.loading = true;
            this.validation.element = event;
            await axios
                .get(
                    this.$store.state.settings.url +
                    "/api/v1/" +
                    this.internalCompany.id +
                    "/" +
                    "validate_pdf/" +
                    event.kooi_id +
                    "/" +
                    this.subkey +
                    "/" +
                    event.id
                )
                .then((response) => {
                    this.validation.infos = response.data.data;
                    this.validation.loading = false;
                });
        },
        acceptDocument(document) {
            this.$store.dispatch("kooi/acceptDocument", { document: document, subkey: this.subkey });
        },
        async cancellationInvoice(document) {
            this.emitter.emit('kooi:menu:invoice:cancel', document);
        },
        openMoreOptions(event, document) {
            if (this.menuOpen == document.id) {
                this.menuOpen = false;
            } else {
                this.menuOpen = document.id;
            }
        },

        createNewInvoice() {
            var subkey = this.subkey;
            this.$store.commit("kooi/loadDocument", { document: null, subkey: subkey });

            if (subkey == 'orders') {
                this.$store.commit("kooi/setOrder", { document: null });
                this.$router.push({ name: "kooi.order-edit", params: { id: this.params.id, type: subkey, document_id: '+' } });
                // this.kooiNavigation.setTabActive(17);
                // this.kooiNavigation.setSubkey(subkey);
            } else {
                // this.kooiNavigation.setTabActive(13);
                // this.kooiNavigation.setSubkey(subkey);
                this.$router.push({ name: "kooi.invoice-edit", params: { id: this.params.id, type: subkey, document_id: "+" } });
            }
        },
    },
    computed: {
        kooi_sales_type() {
            return this.$store.state.kooi.kooi.sales_type;
        },
        params() {
            return this.$route.params;
        },
        navigationActiveTab() {
            return this.kooiNavigation.getActiveTab;
        },
        internalCompany() {
            return this.$store.getters["settings/getActiveCompany"]();
        },
        workingOn() {
            let tmp = [];
            for(let i in this.$store.state.kooi.elementsLoading[this.subkey]){
                if(this.$store.state.kooi.elementsLoading[this.subkey][i].count > 0){
                    tmp.push(this.$store.state.kooi.elementsLoading[this.subkey][i].id);
                }
            }
            return tmp;
        },
        subkey() {
            return this.$route.params.type;
        },
        filteredInvoices() {
            return this.$store.getters["kooi/getTableList"](this.subkey);
        },
        columns() {
            let columns =  this.$store.state.kooi.displayColumns[this.subkey].filter(item => (!item.sales_types || item.sales_types.includes(this.kooi_sales_type)));
            if(isDeveloperMode.value){
                columns.push(...additionalInvoiceColumns.value) ;
            }
            return columns;
        },
        menuViaKeys() {
            if (this.subkey == "orders") {
                return ['data.type', 'status'];
            }
            return 'status';
        },
        menuOptions() {
            if (this.subkey == "orders") {
                var tmp = this.$store.state.kooi.menuOptions;
            } else {
                var tmp = this.$store.state.kooi.menuOptions[this.subkey];
            }
            return tmp;
        },
    }
}
</script>

<style>
.kooi-scroll-container {
    overflow: inherit !important;
}
</style>
